import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';

import { useModal } from 'components/Modal/Modal.hooks';

import styles from 'components/Modal/ModalTypes/WelcomeModal/WelcomeModal.module.scss';

const cn = classNames.bind(styles);

const WelcomeModal = (): ReactElement => {
  const { closeModal } = useModal();

  return (
    <div className={cn('welcome-modal')}>

      <h4 className={cn('welcome-modal__heading')}>
        Welcome to DFA!
      </h4>

      <div className={cn('welcome-modal__description')}>
        <p className={cn('welcome-modal__description-paragraph')}>
          The Digital Freight Alliance is the logistics association created in 2020
          by DP World to unite logistics companies in one community,
          optimizing processes and using digital tools for logistics.
        </p>
        <p className={cn('welcome-modal__description-paragraph', 'is-bold')}>
          All Members receive 5 unique tools
        </p>
      </div>

      <div className={cn('welcome-modal__buttons')}>
        <Link
          className={cn('welcome-modal__button-join')}
          href={'/membership'}
          onClick={closeModal}
        >
          Join Now
        </Link>
      </div>
    </div>
  );
};

export { WelcomeModal };